import type { RoleModule } from '../types';
/* General Sans — the kit's face. The app shell names it (themes.ts) but only
   the dev kit gallery loads the @font-face, so without this every nurse screen
   renders in the system fallback. See the report: main.tsx should own this. */
import '@/components/kit/fonts.css';
/* Lane-local overrides of shared chrome, gated on `.nurse-root` — see the file. */
import './nurse.css';
import { NurseDayPage } from './NurseDayPage';
import { NurseHandOverPage } from './NurseHandOverPage';
import { NurseVitalsPage } from './NurseVitalsPage';
import { NurseTaskPage } from './NurseTaskPage';
import { NurseStockPage } from './NurseStockPage';

/**
 * The nurse surface's routes and door overrides. See ../types.ts.
 * Every route path here must start with `/nurse/`.
 */
const nurse: RoleModule = {
  routes: [
    { path: '/nurse/day', element: <NurseDayPage /> },
    { path: '/nurse/day/hand-over', element: <NurseHandOverPage all={false} /> },
    { path: '/nurse/day/hand-over/all', element: <NurseHandOverPage all /> },
    { path: '/nurse/day/vitals/:id', element: <NurseVitalsPage /> },
    { path: '/nurse/day/task/:id', element: <NurseTaskPage /> },
    { path: '/nurse/day/task/:id/cant', element: <NurseTaskPage cant /> },
    { path: '/nurse/stock', element: <NurseStockPage /> },
  ],
  doorRoutes: {
    myday: '/nurse/day',
    stock: '/nurse/stock',
  },
};

export default nurse;
